import React from "react";
import {OverflowTip} from "./OverflowTip";
import {Chip, ChipProps} from "@mui/material";

/**
 * Uses overflow tip as label wrapper, to show a tooltip on hover if the label is too big
 */
export function OverflowChip(props: ChipProps) {
	return <Chip
		{...props}
		label={<OverflowTip title={props.label}>
			{props.label}
		</OverflowTip>}
	/>;
}
